// extracted by mini-css-extract-plugin
export var numpadContainer = "_sw-1";
export var phoneButton = "_sw-0";